/*
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-28 17:36:40
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-08-26 17:32:51
 */
import moment from 'moment';
import md5 from 'md5';

const throttle = (fun, delay) => {
  let last, deferTimer
  return function () {
    let that = this
    let _args = arguments
    let now = +new Date()
    if (last && now < last + delay) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function () {
        last = now
        fun.apply(that, _args)
      }, delay)
    }else {
      last = now
      fun.apply(that,_args)
    }
  }     
}

const debounce = (fn, delay = 1000) => {
  let timeout = null
  let count = 0
  return function () {
    clearTimeout(timeout)
    if (!count) {
      count++
      fn.apply(this, arguments)
      timeout = setTimeout(() => {
        count = 0
      }, delay)
    } else {
      count++
      timeout = setTimeout(() => {
        fn.apply(this, arguments)
        count = 0
      }, delay)
    }
  }
}

function getDateDiff(_dateTimeStamp) {
  let dateTimeStamp = moment(_dateTimeStamp).valueOf()
  if (!dateTimeStamp) return '-';
  const pattern3 = new RegExp('[0-9]+');
  if (pattern3.test(dateTimeStamp)) {
    if (Number.isNaN(dateTimeStamp) && !Number.isNaN(Date.parse(dateTimeStamp))) return '';
    dateTimeStamp = moment(dateTimeStamp).valueOf();
  }
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = month * 12;
  const now = new Date().getTime();
  const diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return '刚刚';
  }
  const yearC = diffValue / year;
  const monthC = diffValue / month;
  const weekC = diffValue / (7 * day);
  const dayC = diffValue / day;
  const hourC = diffValue / hour;
  const minC = diffValue / minute;

  let result = moment(dateTimeStamp).format("YYYY-MM-DD HH:mm:ss");
  if (yearC >= 1 || monthC >= 1 || weekC >= 3) {
    result = moment(dateTimeStamp).format("YYYY-MM-DD HH:mm:ss") + ' '
  } else if (weekC >= 1) {
    result = `${parseInt(weekC, 0)}周前`;
  } else if (dayC >= 1) {
    result = `${parseInt(dayC, 0)}天前`;
  } else if (hourC >= 1) {
    result = `${parseInt(hourC, 0)}小时前`;
  } else if (minC >= 1) {
    result = `${parseInt(minC, 0)}分钟前`;
  } else {
    result = '刚刚';
  }
  return result;
}

function generateTimestamp() {
  // 获取当前时间的秒数
  const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
  return currentTime.toString();
}

function generateToken() {
  const SECRET = process.env.VUE_APP_BBS_SECRET;
  // 获取当前时间的秒数
  const timestamp = generateTimestamp();

  // 拼接时间戳和密钥
  const data = timestamp + SECRET;
  const token = md5(data);
  // 计算MD5散列值并返回
  return {
    timestamp,
    token,
  };
}

function getQueryString(name, search = window.location.search) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    }
    return null;
 }

const getFansPendantUrl = (fansNumber) => {
  if (!fansNumber) return null;
  if (fansNumber > 49 && fansNumber < 100) {
    return 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-05-26-11-10ZAgMwST26bmJfL12t.png';
  }
  if (fansNumber > 99 && fansNumber < 500) {
    return 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-05-26-11-136iHcaIErzqKROEY.png';
  }
  if (fansNumber > 499 && fansNumber < 1000) {
    return 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-05-26-11-15hxVpRTlkrukosGr.png';
  }
  if (fansNumber > 999) {
    return 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-05-26-11-15sHaHSPOHC7gyz33Y.png';
  }
  return null;
};

const SHENDENG_IMG_URL_MINI = 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/';
const SHENDENG_IMG_URL = 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket/';
const SHENDENG_IMG_URL_OLD = 'https://storage.jd.com/shendengbucket1/';
function getImageUrl(url, width, height) {
  let src = url;
  if (url?.indexOf(SHENDENG_IMG_URL_MINI) === 0) {
    src = url?.replace(SHENDENG_IMG_URL_MINI, SHENDENG_IMG_URL);
    return `${src}?x-oss-process=img/s/${width}/${height}`;
  } else if (url?.indexOf(SHENDENG_IMG_URL_OLD) === 0) {
    src = url?.replace(SHENDENG_IMG_URL_OLD, SHENDENG_IMG_URL);
    return `${src}?x-oss-process=img/s/${width}/${height}`;
  }
  return src;
}

const urlToLink = (str) => {
  const re =
    // eslint-disable-next-line no-useless-escape
    /((http|ftp|https):\/\/)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9\&%_\.\/-~-]*)?/g;

  const linkStr = str.replaceAll(re, (url) => {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });

  return linkStr;
};

const getLinkUrl = (dataHref) => {
  console.log(dataHref)
  if (dataHref.startsWith('http://sd.jd.com/article') || dataHref.startsWith('http://xingyun.jd.com/shendeng/article') || dataHref.startsWith('http://jagile.jd.com/shendeng/article')) {
    const params = dataHref.match(/\d+/g);
    if (params?.length && params[0]) {
      return {
        name: 'articleDetail',
        id: params[0]
      }
    }
  }
  if (dataHref.startsWith('http://sd.jd.com/bbs') || dataHref.startsWith('http://xingyun.jd.com/shendeng/bbs') || dataHref.startsWith('http://jagile.jd.com/shendeng/bbs')) {
    const params = dataHref.match(/\d+/g);
    if (params?.length && params[0]) {
      return {
        name: 'bbsDetail',
        id: params[0]
      }
    }
  }
  return dataHref;
}


export {
  urlToLink,
  getImageUrl,
  throttle,
  debounce,
  getDateDiff,
  generateTimestamp,
  generateToken,
  getQueryString,
  getFansPendantUrl,
  getLinkUrl
}